import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, CloseWrapper } from '@tcc/crate';
import { drawingButtonsHandlers } from '@tcc/treadstone';
import { getMessage } from '@tcc/i18n';
import { REGION_SYMBOLS } from '../../constants/scouting';
import styles from './RegionButton.css';
import { openModal } from '../../actions/modalActions';
import { ModalType, ModalMode } from '../../types';

function RegionButton({ index, showPaywall }) {
  const [open, toggle] = useState(false);
  const dispatch = useDispatch();

  const onClickDrawingTool = (shape) => {
    if (showPaywall) {
      dispatch(openModal(index, null, {
        type: ModalType.PAYWALL,
        mode: ModalMode.PAYWALL_REGION_REPORT,
      }));
    } else {
      drawingButtonsHandlers(shape, index);
    }
  };
  return (
    <CloseWrapper onRootClose={() => toggle(false)}>
      <div className={styles.dropUpWrapper}>
        <Button
          className={styles.regionButton}
          data-test-id="dmb-region-button"
          mode="map"
          onClick={() => toggle(!open)}
        >
          {REGION_SYMBOLS.POLYGON} {getMessage('regions.regionButton')}
        </Button>
        {open && (
          <div className={styles.regionMenu} data-test-id="dmb-region-menu">
            <div
              data-test-id="dmb-region-polygon"
              onClick={() => onClickDrawingTool('polygon')}
              role="button"
              tabIndex={0}
            >
              {REGION_SYMBOLS.POLYGON} {getMessage('regions.polygonButton')}
            </div>
            <div
              data-test-id="dmb-region-rectangle"
              onClick={() => onClickDrawingTool('rectangle')}
              role="button"
              tabIndex={0}
            >
              {REGION_SYMBOLS.RECTANGLE} {getMessage('regions.rectangleButton')}
            </div>
            <div
              data-test-id="dmb-region-pivot"
              onClick={() => onClickDrawingTool('pivot')}
              role="button"
              tabIndex={0}
            >
              {REGION_SYMBOLS.PIVOT} {getMessage('regions.pivotButton')}
            </div>
          </div>
        )}
      </div>
    </CloseWrapper>
  );
}

RegionButton.propTypes = {
  index: PropTypes.number.isRequired,
  setIsExperiments: PropTypes.bool,
  showPaywall: PropTypes.bool.isRequired,
};

export default RegionButton;
